import { useRouter } from "next/router";
import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import useBreadcrumbsInit from "../InitHooks/useBreadcrumbsInit";



const useProduct = (productData) => {

    const router = useRouter();

    const {template_settings} = useSelector((state) => state.globalReducer);
    const {initBreadcrumbs, setLocalBreadcrumbs} = useBreadcrumbsInit();

    const isFirstRender = useRef(true);
    const loadingProducts = useRef(false);
    const initialState = useRef(true);
    
    const [originalRoute, setOriginalRoute] = useState('');
    const [localProductData, setLocalProductData] = useState(productData)

    useEffect(() => {
        setOriginalRoute(router.query.slug)
        initialState.current = false;
        initBreadcrumbs();
    }, [])
    
    useEffect(() => {
        const handleRouteChange = async () => {
            if(!initialState.current && router?.query?.slug != originalRoute && originalRoute != ""){
                await productsReq();
            }
        };
        handleRouteChange();
    }, [router.query.slug, router.events]);

    const productsReq = async () => {
        loadingProducts.current = true;
        const req = await fetch(`${process.env.BASE_API_URL}get-product?slug=${router.query.slug}`);
        const data = await req.json();
        setOriginalRoute(router.query.slug);
        setLocalBreadcrumbs(data.breadcrumb)
        loadingProducts.current = false;
        setLocalProductData(data);
    }

    return {
        localProductData,
        loadingProducts
    }
}

export default useProduct;